const facilitiesSectionResources = {
    findFacilityButtonText: 'Find Facility'
};
export default facilitiesSectionResources;
